import $ from 'jquery';

const selector = '[klickbox-edit-item]:not([klickbox-edit-not-highlight])';

let sidebarChangePanel = null;
let sidebarSetElement = null;
let canvasEnableHighlight = null;
let sidebarChangeActiveButton = null;

const bindClicks = (items) => {
  items.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      sidebarChangePanel('modifiers');
      sidebarChangeActiveButton('style');
      sidebarSetElement(item);
    });
  });
};

const bindHover = (items) => {
  const updateHightlight = (event, element) => {
    if (element.classList.contains('kbx-modal')) {
      return false;
    }

    if (!items.includes(element)) {
      return updateHightlight(event, element.parentElement);
    }

    canvasEnableHighlight({ event: { target: element } });

    event.stopPropagation();

    return true;
  };

  $('.kbx-modal').on('mouseover', selector, (event) => {
    const element = event.target;

    updateHightlight(event, element);
  });
};

export default class Highlight {
  bind(actions) {
    const queryItems = document.querySelectorAll(selector);
    const editItems = Array.from(queryItems);

    sidebarChangePanel = actions.sidebarChangePanel;
    sidebarSetElement = actions.sidebarSetElement;
    canvasEnableHighlight = actions.canvasEnableHighlight;
    sidebarChangeActiveButton = actions.sidebarChangeActiveButton;

    bindClicks(editItems);
    bindHover(editItems);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/highlight/index.js
 **/